import React from 'react';
import codechefLogo from '../Assets/codechefLogo.svg';
import facebookLogo from '../Assets/facebookLogo.svg';
import githubLogo from '../Assets/githubLogo.svg';
import gmailLogo from '../Assets/gmailLogo.svg';
import hackerrankLogo from '../Assets/hackerrankLogo.svg';
import instagramLogo from "../Assets/instagramLogo.svg";
import linkedinLogo from '../Assets/linkedinLogo.svg';
import topcoderLogo from '../Assets/topcoderLogo.svg';
import twitterLogo from '../Assets/twitterLogo.svg';

const ContactData = [
    {
        type: "work",
        link1: "haidersultanarc@gmail.com",
        site1: "EMAIL",
        logo1: <img className="code__body__lineOutput__logo" src={gmailLogo} alt="Gmail" />,
        link2: "https://github.com/HaiderSultanArc",
        site2: "GITHUB",
        logo2: <img className="code__body__lineOutput__logo" src={githubLogo} alt="Github" />,
        link3: "https://www.linkedin.com/in/haidersultanarc",
        site3: "LINKEDIN",
        logo3: <img className="code__body__lineOutput__logo" src={linkedinLogo} alt="LinkedIn" />,
    },
    {
        type: "social",
        link1: "https://www.facebook.com/haidersultanarc",
        site1: "FACEBOOK",
        logo1: <img className="code__body__lineOutput__logo" src={facebookLogo} alt="Facebook" />,
        link2: "https://www.instagram.com/haidersultanarc",
        site2: "INSTAGRAM",
        logo2: <img className="code__body__lineOutput__logo" src={instagramLogo} alt="Instagram" />,
        link3: "https://twitter.com/HaiderSultanArc",
        site3: "TWITTER",
        logo3: <img className="code__body__lineOutput__logo" src={twitterLogo} alt="Twitter" />
    },
    {
        type: "coding",
        link1: "https://www.hackerrank.com/haidersultanarc",
        site1: "HACKERRANK",
        logo1: <img className="code__body__lineOutput__logo" src={hackerrankLogo} alt="HackerRank" />,
        link2: "https://www.codechef.com/users/haidersultan",
        site2: "CODECHEF",
        logo2: <img className="code__body__lineOutput__logo" src={codechefLogo} alt="CodeChef" />,
        link3: "https://www.topcoder.com/members/HaiderSultanArc",
        site3: "TOPCODER",
        logo3: <img className="code__body__lineOutput__logo" src={topcoderLogo} alt="TopCoder" />
    },
];

export default ContactData;


// WEBPACK FOOTER //
// ./src/Components/Contact/Data/ContactData.js